const getProductCardInfo = (item, html) => {
  const parsedTitle = item.title.indexOf('|') == -1 ? item.title : item.title.split('|')[0];
  const startingPrice = !!item.meta?.bundles?.bundle_price ? item.meta.bundles.bundle_price : item.price;

  // Product subtitle concatenation
  const needsSeparator = (item.meta?.custom?.size_unit || item.options?.size) && item.options?.color ? true : false;
  let productSubtitle = null;
  if (item.meta?.custom?.size_unit || item.options?.size || item.options?.color) {
    productSubtitle = html `<span>${(item.meta?.custom?.size_unit || item.options?.size)}${needsSeparator ? ' | ' : ''}${item.options?.color}</span>`;
  }

  return {
    parsedTitle,
    startingPrice,
    productSubtitle,
  };
};

document.addEventListener('algolia.hooks.initialize', function() {
  // Search autocomplete in header product card
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      const { html, item, components } = templateOptions;
      const { startingPrice } = getProductCardInfo(item, html);
      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem"
          onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
        >
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${algoliaShopify.helpers.compactImage(item)}"
                alt="${item.title}"
              />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: "title" })}
                  <span class="algolia-variant">
                    ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                  </span>
                </div>
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">
                  ${algoliaShopify.helpers.displayPrice({price: parseInt(startingPrice), currency: item.currency}, false)}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );

  // Search page template
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    let searchString = params.q;
    return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle} "${searchString}"</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          ${elva.algoliaFiltersLabel}
        </div>
        <div class="ais-facets" role="region" aria-label="${window?.accessibilityStrings?.filters}">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            (facet, index) =>
              html`
                <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                  <label for="${facet.escapedName}" class="ais-header ais-range-slider--header ais-facet--header">
                    ${facet.title}
                    <svg class="ais-header__arrow-down" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
                      <path d="M22.12 11.4531L16 17.5598L9.88 11.4531L8 13.3331L16 21.3331L24 13.3331L22.12 11.4531Z" fill="#101010"/>
                    </svg>
                  </label>
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                    checked="${index === 0 ? false : true}"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display u-hide">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

  // Search page results stats
  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function(_defaultTemplate, data, html) {
    return html`
      ${data.hasOneResult &&
        html`
          <span class="ais-stats--nb-results">
            ${algoliaShopify.translations.oneResultFound}
          </span>
        `}
      ${data.hasManyResults &&
        html`
          ${data.page * data.hitsPerPage + 1} - ${' '}
          ${Math.min((data.page + 1) * data.hitsPerPage, data.nbHits)} ${' '}
          ${algoliaShopify.translations.outOf}
          <span class="ais-stats--nb-results">
            ${' '} ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '}
            ${algoliaShopify.translations.resultsFound}
          </span>
        `}
    `;
  });

  // Search page product cards
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    const {
      parsedTitle,
      startingPrice,
      productSubtitle,
    } = getProductCardInfo(hit, html);

    // Product badge hierarchy
    const productBadges = [];

    // Always show the "Unavailable" badge if applicable
    if (!hit.inventory_available) {
      productBadges.push(html `<span class="ais-hit__badge--unavailable">${window?.algoliaStrings?.unavailableBadge}</span>`);
    }
    if (hit.meta?.custom?.badge?.toLowerCase() === 'gated') {
      productBadges.push(html `<span class="ais-hit__badge">${window?.algoliaStrings?.gatedBadge}</span>`);
    } else if (hit.meta.custom.is_customizable && window?.algoliaFeatureFlags?.enableCustomize) {
      productBadges.push(window?.algoliaStrings?.customizeBadge);
    } else if (hit.compare_at_price > hit.price) {
      productBadges.push(html `<span class="ais-hit__badge--sale">${window?.algoliaStrings?.saleBadge}</span>`);
    } else if (hit.meta.custom.badge) {
      if (hit.meta.custom.badge.toLowerCase() == 'sale') {
        productBadges.push(html `<span class="ais-hit__badge--sale">${window?.algoliaStrings?.saleBadge}</span>`);
      } else if (hit.meta.custom.badge.toLowerCase() == 'new') {
        productBadges.push( html `<span class="ais-hit__badge--new-icon"><svg aria-hidden="true" data-badge-icon="New" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.375 2.25L15.2723 8.42175L21.75 9.41175L17.0625 14.2162L18.1688 21L12.375 17.7975L6.58125 21L7.6875 14.2162L3 9.41175L9.47775 8.42175L12.375 2.25Z" fill="#101010"/></svg>${window?.algoliaStrings?.newBadge}</span>`);
      } else {
        productBadges.push(hit.meta.custom.badge);
      }
    }

    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
        role="group"
        aria-label="${hit.title}" 
      >
        <div class="ais-hit__badge">${productBadges}</div>
        <img
          class="ais-hit--picture"
          src="${algoliaShopify.helpers.mediumImage(hit)}"
          alt="${hit.title} - ${hit.variant_title}"
        />

        <div class="ais-hit--details">
          <h2 class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              onclick="void(0)"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit.variant_title
              )}"
            >
              ${parsedTitle}
            </a>
          </h2>
          <p class="ais-hit--variant">${productSubtitle}</p>
          <p class="ais-hit--price">
            <strong>${algoliaShopify.helpers.displayPrice({price: parseInt(hit.price), currency: hit.currency}, false)}</strong>
          </p>
        </div>
      </div>
    `;
  });

  //Recommend click and conversion  
  algoliaShopify.hooks.registerHook('beforeRecommendHitTemplate', function(_defaultTemplate, html, item) {
    const {
      parsedTitle,
      startingPrice,
    } = getProductCardInfo(item, html);

    let productBadgeSvg;
    let productBadge;
    switch (item.meta?.custom?.badge?.toLowerCase() ) {
      case 'coming soon':
        productBadgeSvg = html`<svg data-badge-icon="Coming Soon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12C4 7.58172 7.58172 4 12 4C14.4462 4 16.6365 5.09731 18.1051 6.82974C18.1875 6.92695 18.1793 7.07072 18.0892 7.16084L16.9268 8.32322C16.7693 8.48071 16.8808 8.75 17.1036 8.75H21.25C21.3881 8.75 21.5 8.63807 21.5 8.5V4.35355C21.5 4.13083 21.2307 4.01929 21.0732 4.17678L19.8616 5.38843C19.7578 5.4922 19.5876 5.48449 19.4903 5.37462C17.6592 3.30612 14.9823 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.2454 22 12.489 21.9911 12.7303 21.9737C12.868 21.9637 12.9685 21.8412 12.9551 21.7038L12.8098 20.2108C12.7965 20.0734 12.6742 19.9732 12.5365 19.9823C12.3593 19.994 12.1804 20 12 20C7.58172 20 4 16.4183 4 12ZM16.4936 20.9357C16.617 20.8736 16.6626 20.7217 16.5974 20.6L15.8892 19.2778C15.824 19.156 15.6727 19.1106 15.549 19.1719C15.2312 19.3295 14.9014 19.4666 14.5616 19.5814C14.4308 19.6256 14.3559 19.7648 14.396 19.8969L14.8309 21.3325C14.8709 21.4646 15.0106 21.5396 15.1417 21.4962C15.6086 21.3418 16.0602 21.154 16.4936 20.9357ZM19.5689 18.5356C19.6592 18.4312 19.6435 18.2734 19.5368 18.1857L18.3779 17.2335C18.2712 17.1459 18.1139 17.1616 18.023 17.2655C17.7876 17.5345 17.5345 17.7876 17.2655 18.023C17.1616 18.1139 17.1459 18.2712 17.2335 18.3779L18.1857 19.5368C18.2734 19.6435 18.4312 19.6592 18.5356 19.5689C18.9046 19.25 19.25 18.9046 19.5689 18.5356ZM21.4962 15.1417C21.5396 15.0106 21.4646 14.8709 21.3325 14.8309L19.8969 14.396C19.7648 14.3559 19.6256 14.4308 19.5814 14.5616C19.4666 14.9014 19.3295 15.2312 19.1719 15.549C19.1106 15.6727 19.156 15.824 19.2778 15.8892L20.6 16.5974C20.7217 16.6626 20.8736 16.617 20.9357 16.4936C21.154 16.0602 21.3418 15.6086 21.4962 15.1417ZM21.9969 12.25C22.0003 12.1119 21.8881 12 21.75 12H20.25C20.1119 12 20.0004 12.112 19.9962 12.25C19.9932 12.3459 19.9886 12.4415 19.9823 12.5365C19.9732 12.6742 20.0734 12.7965 20.2108 12.8098L21.7038 12.9551C21.8412 12.9685 21.9637 12.868 21.9737 12.7303C21.9852 12.5711 21.993 12.411 21.9969 12.25ZM13 12.4822C13 12.5485 13.0263 12.6121 13.0732 12.659L15.5303 15.1161C15.628 15.2137 15.628 15.372 15.5303 15.4697L14.4697 16.5303C14.372 16.628 14.2137 16.628 14.1161 16.5303L11.0732 13.4874C11.0263 13.4406 11 13.377 11 13.3107V7.25C11 7.11193 11.1119 7 11.25 7H12.75C12.8881 7 13 7.11193 13 7.25V12.4822Z" fill="#101010"/></svg>`;
        productBadge = html`<span data-product-badge="${window?.algoliaStrings?.comingSoonBadge}">${window?.algoliaStrings?.comingSoonBadge}</span>`;
        break;
      case 'best seller':
        productBadgeSvg = html`<svg data-badge-icon="Best Seller" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5642 11.3237C11.2169 11.9886 10.8831 12.6073 10.5705 13.2355C9.82444 14.7349 9.08506 16.2367 8.35238 17.7409C7.96648 18.5348 7.74227 19.3713 7.72414 20.248C7.70137 21.3529 8.0178 22.3739 8.6225 23.3182C8.64566 23.3545 8.66997 23.3909 8.69274 23.4272C8.80156 23.6002 8.7977 23.7597 8.68193 23.8796C8.55651 24.0096 8.37321 24.0456 8.19223 23.9312C7.6979 23.6176 7.17308 23.332 6.7347 22.9578C5.33699 21.7649 4.41508 20.3021 4.11061 18.5308C3.86325 17.0924 4.04154 15.6863 4.5378 14.3114C4.96884 13.116 5.60673 12.0224 6.39318 11.005C7.77469 9.21811 8.88993 7.30222 9.59071 5.18468C10.0538 3.79055 10.3158 2.36626 10.3015 0.901636C10.3015 0.768654 10.2957 0.634945 10.2807 0.501963C10.2602 0.31775 10.2668 0.145164 10.4648 0.0445193C10.6708 -0.0601224 10.8294 0.0368891 10.9869 0.158244C11.7768 0.769381 12.4031 1.50878 12.9129 2.33828C13.7026 3.61116 14.1812 5.03369 14.3141 6.50251C14.3843 7.27351 14.3843 8.04997 14.4333 8.82279C14.4719 9.4332 14.5433 10.0429 14.7845 10.6166C14.8787 10.8341 15.0078 11.0366 15.1673 11.2172C15.3425 11.4167 15.5474 11.3901 15.7156 11.1809C15.9248 10.9218 16.0143 10.613 16.0437 10.3016C16.0884 9.8267 16.0961 9.34854 16.1031 8.87148C16.1054 8.69562 16.1251 8.54266 16.3068 8.45727C16.4979 8.36753 16.6499 8.43983 16.7919 8.56627C17.5942 9.28569 18.1479 10.1602 18.5975 11.098C19.3593 12.6869 19.8571 14.3477 19.9736 16.0896C20.1025 18.0422 19.7552 19.901 18.5543 21.5535C17.8161 22.569 16.8394 23.3302 15.6859 23.8974C15.5142 23.982 15.3506 23.9846 15.2101 23.8469C15.0847 23.723 15.0685 23.5773 15.1611 23.4301C16.1324 21.8906 16.0873 20.2909 15.4826 18.6584C15.1555 17.7906 14.6929 16.9736 14.1099 16.2342C12.9862 14.7892 12.1878 13.1963 11.6236 11.493C11.6105 11.4534 11.5958 11.4145 11.5642 11.3237Z" fill="#101010"/></svg>`;
        productBadge = html`<span data-product-badge="${window?.algoliaStrings?.bestSellerBadge}">${window?.algoliaStrings?.bestSellerBadge}</span>`;
        break;
      case 'limited edition':
        productBadgeSvg = html`<svg data-badge-icon="Limited Edition" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 2C1.10459 2 2 2.89543 2 4C2 2.89541 2.89541 2 4 2C2.89541 2 2 1.10457 2 0C2 1.10459 1.10459 2 0 2Z" fill="#101010"/><path d="M9 6C9 4.34315 7.65688 3 6 3C7.65688 3 9 1.65688 9 0C9 1.65685 10.3431 3 12 3C10.3431 3 9 4.34312 9 6Z" fill="#101010"/><path d="M6 13C6 10.7909 4.20918 9 2 9C4.20918 9 6 7.20918 6 5C6 7.20913 7.79082 9 10 9C7.79082 9 6 10.7908 6 13Z" fill="#101010"/><path d="M15 24C15 19.0295 10.9707 15 6 15C10.9707 15 15 10.9707 15 6C15 10.9705 19.0293 15 24 15C19.0293 15 15 19.0293 15 24Z" fill="#101010"/></svg>`;
        productBadge = html`<span data-product-badge="${window?.algoliaStrings?.limitedEditionBadge}">${window?.algoliaStrings?.limitedEditionBadge}</span>`;
        break;
      case 'sale':
        productBadgeSvg = html`<svg data-badge-icon="Sale" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.1478 7.00569C21.367 7.22489 21.4721 7.53334 21.4325 7.84078L21.0002 11.1905C20.9719 11.4096 20.8718 11.6133 20.7155 11.7696L9.87857 22.6066C9.48805 22.9971 8.85488 22.9971 8.46436 22.6066L1.39348 15.5357C1.00296 15.1451 1.00295 14.512 1.39348 14.1215L12.2305 3.28448C12.3867 3.1282 12.5904 3.0281 12.8096 2.99981L16.1592 2.56756C16.4667 2.52789 16.7751 2.63303 16.9943 2.85223L21.1478 7.00569ZM14.8285 9.17169C15.4143 9.75748 16.3641 9.75748 16.9498 9.17169C17.5356 8.58591 17.5356 7.63616 16.9498 7.05037C16.3641 6.46459 15.4143 6.46459 14.8285 7.05037C14.2427 7.63616 14.2427 8.58591 14.8285 9.17169Z" fill="#101010"/></svg>`;
        productBadge = html`<span data-product-badge="${window?.algoliaStrings?.saleBadge}">${window?.algoliaStrings?.saleBadge}</span>`;
        break;
      case 'new':
        productBadgeSvg = html`<svg data-badge-icon="New" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.375 2.25L15.2723 8.42175L21.75 9.41175L17.0625 14.2162L18.1688 21L12.375 17.7975L6.58125 21L7.6875 14.2162L3 9.41175L9.47775 8.42175L12.375 2.25Z" fill="#101010"/></svg>`;
        productBadge = html`<span data-product-badge="${window?.algoliaStrings?.newBadge}">${window?.algoliaStrings?.newBadge}</span>`;
        break;
      case 'leakproof':
        productBadgeSvg = html`<svg data-badge-icon="Leakproof" width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.9999 6.87821L19.6141 3.2894L18.3862 1.71069L14.0989 5.04527C12.3414 1.95927 10 0 10 0C10 0 4 5.02078 4 11.6471C4 12.048 4.03507 12.4402 4.10215 12.8205L0.38623 15.7107L1.61411 17.2894L4.79728 14.8136C5.83337 16.718 7.77528 18 10 18C13.3137 18 16 15.1557 16 11.6471C16 9.9298 15.597 8.32036 14.9999 6.87821ZM14 11.6471C14 14.1604 12.103 16 10 16C8.48226 16 7.0718 15.0418 6.4043 13.5637L13.3527 8.15941C13.7513 9.25638 14 10.4298 14 11.6471ZM6.00524 11.3404C6.09387 8.73898 7.29441 6.35278 8.62311 4.50723C9.10132 3.843 9.5806 3.27058 10 2.80868C10.4194 3.27058 10.8987 3.843 11.3769 4.50723C11.7718 5.05574 12.1554 5.652 12.5018 6.28748L6.00524 11.3404Z" fill="#101010"/></svg>`;
        productBadge = html`<span data-product-badge="${window?.algoliaStrings?.leakproofBadge}">${window?.algoliaStrings?.leakproofBadge}</span>`;
        break;
      default:
        productBadgeSvg = '';
        productBadge = '';
        break;
    }

    const variantUrl = `/products/${item.handle}?variant=${item.objectID}`;
    const isSingleVariant = (item.variants_count === 1);
    const startingAtLabel = (item.variants_min_price < item.variants_max_price ) ? window?.algoliaStrings?.startingAtLabel:'';
    const salePriceClass  = (startingPrice < item.compare_at_price) ? 'u-colorRed' : '';
    const colorLabel = isSingleVariant ? item.option_names?.[0] : window?.algoliaStrings?.colorsOptionLabel
    const showCustomize = !!window?.algoliaFeatureFlags?.enableCustomize && !!item.meta.custom?.is_customizable;
    const doesBadgeContainShip = !!item.meta.custom?.badge?.includes('Ship');

    let productCardSizeTitleCountCopy = `${item.variant_title} | ${item.variants_count} ${colorLabel}`;
    const productSize = item.meta?.custom?.size_unit || item.options?.size;
    if (productSize) {
      productCardSizeTitleCountCopy = `${productSize} | ${productCardSizeTitleCountCopy}`;
    }

    return html`
      <div class="c-gridItem piAnalytics c-gridItem--large">
        <div class="c-gridItem__inner c-gridItem--hover">
          <div>
            <div class="c-gridItem__imageWrapper">
              <div class="c-gridItem__badgeWrapper">
                <div class="c-gridItem__badge">
                  ${productBadgeSvg}
                  ${productBadge}
                </div>
                ${
                  showCustomize
                    ? html`
                      <a
                        class="c-gridItem__customize c-linkHover c-linkHover--reverse ${!showCustomize ? 'c-gridItem__customize--disabled' : ''} ${doesBadgeContainShip ? 'c-gridItem__customize--shipping-badge' : ''}"
                        href="${variantUrl}"
                        data-customizable
                        data-id="${item.id}"
                      >
                          ${window?.algoliaStrings?.customizeBadge}
                        </a>`
                    : ''
                }
              </div>
              <a
                class="c-gridItem__imageLink"
                href="${variantUrl}"
              >
                <div class="u-relative">
                  <div class="c-gridItem__imageContainer">
                    <img
                      class="c-gridItem__image gridItemClick u-full"
                      src="${algoliaShopify.helpers.mediumImage(item)}"
                      loading="lazy"
                      alt="${parsedTitle}"
                    />
                  </div>
                  ${item.inventory_available ? '' : html`<div class="c-gridItem__soldOutBadge">${window?.algoliaStrings?.unavailableBadge}</div>`}
                </div>
              </a>
            </div>

            <div class="c-gridItem__textWrapper">
              <div class="c-gridItem__copy">
               <span>${productCardSizeTitleCountCopy}</span>
              </div>

              <a
                class="c-gridItem__title c-linkHover"
                href="${variantUrl}"
              >
                <h5>${parsedTitle}</h5>
              </a>

              <div
                class="c-gridItem__bvRating"
                data-bv-show="inline_rating"
                data-bv-product-id="${item.id}"
                data-bv-redirect-url="${variantUrl}"
                data-bv-seo="false"
              ></div>
            </div>
          </div>

          <div class="u-relative">
            <div class="${isSingleVariant ? '' : 'u-hide'}">
              <div class="c-gridItem__price ${salePriceClass}">
                ${algoliaShopify.helpers.displayPrice({price: parseInt(startingPrice), currency: item.currency}, false)}
              </div>
              ${
                item.compare_at_price > 0 && item.compare_at_price !== item.price
                  ? html`
                    <div class="c-gridItem__price u-strike">
                      ${algoliaShopify.helpers.displayPrice({price: parseInt(item.compare_at_price), currency: item.currency}, false)}
                    </div>
                  `
                  : ''
              }
            </div>
            <div class="${isSingleVariant ? 'u-hide' : ''}">
              <div class="c-gridItem__price">
                ${startingAtLabel} ${algoliaShopify.helpers.displayPrice({price: parseInt(item.variants_min_price), currency: item.currency}, false)}
              </div>
            </div>
          </div>
        </div>
      </div>`;
  });
});